<template>
    <div class="text-margin">
        <el-row>
            <el-col :span="4">
                <p>姓名：</p>
            </el-col>
            <el-col :span="16">
                <p> {{ data.identity_info.card_name }} </p>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="4">
                <p>身份证号：</p>
            </el-col>
            <el-col :span="16">
                <p> {{ data.identity_info.card_number }} </p>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="12">
                <p>人像面</p>
                <el-image :src="'data:image/jpeg;base64,' + data.identity_info.card_positive"/>
            </el-col>
            <el-col :span="12">
                <p>国徽面</p>
                <el-image :src="'data:image/jpeg;base64,' + data.identity_info.card_back"/>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="4">
                <p>银行名称：</p>
            </el-col>
            <el-col :span="16">
                <p> {{ getBankName(data.finance_info.bank_code) }} </p>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="4">
                <p>开户行：</p>
            </el-col>
            <el-col :span="16">
                <p> {{ data.finance_info.bank_opening }} </p>
            </el-col>
        </el-row>
        
        <el-row>
            <el-col :span="4">
                <p>银行卡号：</p>
            </el-col>
            <el-col :span="16">
                <p> {{ data.finance_info.card_number }} </p>
            </el-col>
        </el-row>
        
        <el-row>
            <el-col :span="4">
                <p>审核状态:</p>
            </el-col>
            <el-col :span="16">
                <el-select v-model="valid" placeholder="请选择">
                    <el-option
                        v-for="item in status"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>            
            </el-col>
        </el-row>
        
        <el-row v-if="!valid">
            <el-col :span="4">
                <p>失败原因:</p>
            </el-col>
            <el-col :span="16">
                <el-select v-model="message" placeholder="请选择">
                    <el-option
                        v-for="(item, index) in failMessage"
                        :key="index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>            
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import request from "../../../../api/request"
export default {
    name: 'FormWithdrawVerify.vue',
    props: {
        value: {
            type: Object,
            default: function () {
                return { valid: null , message: null }
            }
        }
    },
    data() {
        return {
            data: {
                finance_info: {
                    bank_code: null,
                    bank_opening: null,
                    card_number: null
                },
                identity_info: {
                    card_back: null,
                    card_name: null,
                    card_number: null,
                    card_positive: null
                }
            },
            bankList: null,
            status: [
                {
                    value: true,
                    label: '审核通过'
                }, 
                {
                    value: false,
                    label: '审核失败'
                }
            ],
            failMessage: [
                '通道故障',
                '账户名、卡号或开户行错误',
                '非本人银行卡',
                '账户存在风险',
                '账户涉嫌违规',
                '其他原因'
            ]
        }
    },
    created(){        
        this.uid = parseInt(this.$route.params.uid)
        this.getIdentity()
        this.getBankList()
    },
    mounted(){
    },
    methods: {
        getIdentity() {
            request.wallet.post('withdraw_info_get', {
                withdraw_id: this.uid
            })
            .then(response => {
                this.data = response.data
                if (this.data.withdraw_info.user_id) {
                    this.$emit('input-uid', this.data.withdraw_info.user_id)
                }
            }) 
        },
        getBankList() {
            request.front.post('bank_list')
            .then(response => {
                this.bankList = response.data
            }) 
        },
        getBankName(key) {
            let bank = {}
            if (key && this.bankList) {
                bank = this.bankList.find(b => b.code === key)
            }
            return bank ? bank.name : ''
        }
    },
    computed: {
        valid: {
            get: function() {
                return this.value ? this.value.valid : ''
            },
            set: function(value) {
                this.$emit('input', Object.assign({ valid: value }, value ? {} : { message: this.message }))
            }
        },
        message: {
            get: function() {
                return this.value ? this.value.message : ''
            },
            set: function(value) {
                this.$emit('input', {valid: this.valid, message: value})
            }
        } 
    }
}
</script>

<style scoped>
</style>
